module.exports = __webpack_public_path__ + "static/img/mapa-fra.4b7dbdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/mapa-fra.png
// module id = JlzC
// module chunks = 0